import React, { useEffect, useState } from 'react';
import tickMark from "../../../../assets/img/clinicalAssets/tick.svg";
import tickMarkActive from "../../../../assets/img/clinicalAssets/tickActive.svg";
import { Line, Area, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, ComposedChart } from "recharts";
import axios from "axios";
import AnalyticsTable from '../../../AllComponents/AnalyticsTable';

const NPS = () => {
  const [chartData, setChartData] = useState([]);
  const [showRegionData, setShowRegionData] = useState(false);
  const [months, setMonths] = useState('');
  const [npsData, setNpsData] = useState([])
  const [responseData, setResponseData] = useState({});
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const getNPSData = async () => {
      const { data } = await axios.get('https://drkpeyes-api.ignithocloud.com/api/dashboard/clinical/nps/getData');
      setLoading(true);
      setResponseData(data);
      setChartData(data.overallData);
      setNpsData(data.result);
      setMonths(data.months);
      setLoading(false);
    }
    getNPSData();
  }, [])

  const getMyData = (x) => {
    const dataMin = Math.min(...chartData.map((i) => i.myData), ...chartData.map((i) => i.region), ...chartData.map((i) => i.platform));    
    const dataMax = Math.max(...chartData.map((i) => i.myData), ...chartData.map((i) => i.region), ...chartData.map((i) => i.platform));
    const absMax = Math.max(Math.abs(dataMin), Math.abs(dataMax));
    const roundedVal = Math.ceil(absMax / 10) * 10;
    if (dataMin < 0) {
      return [-roundedVal, x.myData];
    }
    if (dataMin > 0) {
      return [roundedVal, x.myData];
    }
  }

  const CustomizedXAxisTick = ({ x, y, payload }) => {
    const lines = payload.value.split(' ');
    return (
      <g transform={`translate(${x},${y})`}>
        {lines.map((line, index) => (
          <text key={index} x={0} y={index * 13} textAnchor="middle" fill="#989899" fontSize={8}>
            {line}
          </text>
        ))}
      </g>
    );
  };

  return (
    <div>
      {loading ?
        <div className='absolute w-full bg-white top-[10rem] bottom-[3.5rem]'>
          <div className="flex justify-center mt-48">
            <div role="status">
              <svg aria-hidden="true" class="inline w-8 h-8 mr-2 text-gray-200 animate-spin dark:text-gray-600 fill-[#1B453E]" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor" />
                <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill" />
              </svg>
              <span className="sr-only">Loading...</span>
            </div>
          </div>
        </div> : <div>
          <div className='bg-white'>
            <div className='flex justify-center'>
              <p className='font-display-regular text-lite-black text-[0.75rem] text-center tracking-wide pb-3'>Data from {months} - Comparison <br /> with Region and Platform medians</p>
            </div>

            {/* comparative Analytics Graph */}
            <div style={{ height: "200px", width: '100%', paddingRight: '10px' }}>
              <ResponsiveContainer>
                <ComposedChart
                  data={chartData}
                  margin={{
                    top: 5,
                    right: 8,
                    bottom: 0,
                    left: -20
                  }}
                >
                  <defs>
                    <linearGradient id="colorUv" x1="0" y1="0" x2="0" y2="1">
                      <stop offset="40%" stopColor="#34B5FE" stopOpacity={1} />
                      <stop offset="99%" stopColor="#34B5FE" stopOpacity={0} />
                    </linearGradient>
                  </defs>
                  <CartesianGrid horizontal={false} stroke='#EFEDED' />
                  <XAxis axisLine={false} interval={0} tickLine={false} dataKey="month" tick={<CustomizedXAxisTick />} tickMargin={5} />
                  <YAxis axisLine={false} type="number" tick={{ fontSize: 8, fill: "#989899", fontFamily: 'SF-Pro-Display-Regular' }} tickLine={false} tickMargin={5} domain={([dataMin, dataMax]) => { const absMax = Math.max(Math.abs(dataMin), Math.abs(dataMax)); const roundedVal = Math.ceil(absMax / 10) * 10; return [-roundedVal, roundedVal]; }} allowDataOverflow={true} />
                  <Tooltip />
                  <Area type='linear' dataKey={getMyData} fill="url(#colorUv)" stroke="false" dot={{ stroke: '#FFFFFF', strokeWidth: 1, fill: '#1c8bc8', r: 3 }} />
                  <Line dataKey="platform" stroke="#FF9300" dot={false} />
                  {showRegionData ? <Line dataKey="region" stroke="#7CC84A" dot={false} /> : ''}
                </ComposedChart>
              </ResponsiveContainer>
            </div>

            <div className='flex justify-center mt-5 gap-1'>
              {showRegionData ? <img src={tickMarkActive} alt="tickMarkActive" onClick={() => setShowRegionData(false)} /> : <img src={tickMark} alt="tickMark" onClick={() => setShowRegionData(true)} />
              }
              <p className='text-[#989899] font-display-regular text-[0.75rem]'>Show region benchmark in the graph</p>
            </div>

            {/* Comparative Analytics Table */}
            <div className='mx-4 mt-4'>
              <table className="font-display-regular text-center text-[0.625rem] text-lite-black w-full table-fixed" >
                <tbody>
                  <tr>
                    <td className='py-2 font-display-medium'>Month</td>
                    <td><span className="w-2.5 h-2.5 bg-[#34B5FE] inline-block rounded-full me-1"></span>NPS<br /><span className='ms-5'>My Data</span></td>
                    {showRegionData ?
                      <td className='py-2'><span className='w-2.5 h-0.5 bg-[#7CC84A] inline-block me-1'></span>NPS<br /><span className='ms-6'>Region</span></td> : ''}
                    <td className='py-2'><span className='w-2.5 h-0.5 bg-[#FF9300] inline-block me-1'></span>NPS<br /><span className='ms-6'>Platform</span></td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <div className='bg-white overflow-y-scroll absolute top-[31.7rem] bottom-[3.5rem] no-scrollbar w-full'>
            <AnalyticsTable tableData={npsData} showRegionData={showRegionData} />
            <AnalyticsTable avg={true} showRegionData={showRegionData} myDataOverallAvg={responseData.myDataOverallAvg} regionOverallAvg={responseData.regionOverallAvg} platformOverallAvg={responseData.platformOverallAvg} />
          </div>
        </div>
      }
    </div>

  )
}

export default NPS;
